import React, { useEffect } from 'react'
import { classes, style } from 'typestyle'
import { Box } from '../../../components/box/box.component'
import { Sidebar } from '../../../components/sidebar'
import { Text } from '../../../components/text/text.component'

/* Core ========================================================================================= */
import { addSnippet } from '../../../core/snippet-manager'

/* Hooks ======================================================================================== */
import useArray from '../../../hooks/use-array'
import useFetch from '../../../hooks/use-fetch'
import { useParams } from 'react-router-dom'

/* Components =================================================================================== */
import { getCurrentUser } from '../../../services/auth'
import '../../sidebars/notifications'

/* Styles ======================================================================================= */
import { mr8 } from '../../../styles/styleset/margin/mr8'
import { Loader } from '../../../components/loader'
import Skeleton from '../../../components/skeleton'

export default addSnippet('Greeting', () => {
  const { currentUser } = getCurrentUser()
  const [actionItems, $actionItems] = useArray()
  const { groupId } = useParams()

  const apiUrl = `${process.env.REACT_APP_API_URL}/a/notifications/unread-count`
  const [unreadCount, $unreadCount] = useFetch<{
    actionItems: number
    notifications: number
  }>(
    { actionItems: 0, notifications: 0 },
    {
      url: apiUrl,
    },
  )

  useEffect(() => {
    if (unreadCount.mounted) {
      $unreadCount.get()
    }
  }, [unreadCount.mounted])

  return (
    <Box
      rounded
      baseline="surface"
      className={classes(
        style({
          marginBottom: 16,
          padding: '16px 16px',
          overflow: 'hidden',
          height: 48,
          cursor: 'pointer',
        }),
      )}
      shadow
      shadowContrast="light"
      flex
      alignCenterY
      relative
    >
      <Box
        style={{
          left: 0,
          top: 0,
          width: 4,
          background: '#266ffb',
          height: '100%',
          position: 'absolute',
        }}
      ></Box>
      <Text size="md" className={mr8}>
        👋
      </Text>
      <Text baseline="surface" size="md">
        {`Hello ${currentUser?.firstName || 'There'}! 
                You currently have `}
        <Loader
          loaded={!unreadCount.meta.isLoading}
          skeleton={<Skeleton variant="text" width={150} />}
          component={
            <Text
              baseline="surface"
              link
              size="md"
              semiBold={actionItems.length > 0}
              onClick={() => {
                Sidebar.push({
                  type: 'Notifications',
                  componentProps: {
                    unreadCount,
                    $unreadCount,
                  },
                })
              }}
            >
              {`${unreadCount.payload.actionItems} action ${
                unreadCount.payload.actionItems !== 1 ? 'items' : 'item'
              }.`}
            </Text>
          }
        />
      </Text>
    </Box>
  )
})
